// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + "PackagePicker-Widget-ListV2" + ".chunk.min.css";
};